//@ts-nocheck

export const AnimateVideoSlider = async () => {
  animateSection();
};

function animateSection() {
  gsap.registerPlugin(ScrollTrigger);

  gsap.to(".boxes--slider.even", {
    opacity: 1,
    ease: "none",
    scrollTrigger: {
      trigger: ".boxes--slider.even",
      start: "top 60%",
      end: "30% 30%",
      toggleActions: "restart resume resume reverse",
      // markers: true,
      id: "boxEven",
    },
  });

  gsap.utils
    .toArray(".sectionCualSeToma--videoImagen")
    .forEach((section, i) => {
      // let box = section.querySelector('.boxes')
      // let boxWidth = box.clientWidth
      // let boxesContent = box.querySelectorAll('.boxes--slider')
      let boxEven = section.querySelector(".boxes--slider.even");
      let boxOdd = section.querySelector(".boxes--slider.odd");

      let videoImagen = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: "+=700",
          ease: "ease",
          scrub: 1,
          pin: true,
          pinSpacing: true,
          toggleActions: "play none none none",
          // markers: true,
          id: `videoImagen`,
        },
      });

      videoImagen.to(boxOdd, {
        xPercent: -30,
      });

      // let lastItem
      // const totalItems = boxesContent.length

      // boxesContent.forEach((item, index) => {
      //     console.log(index, totalItems)

      //     if (item.classList.contains('even')) {
      //         if (totalItems == index+1) {
      //             let widthOdd = item.clientWidth
      //             item.style.right = `-${widthOdd}px`
      //             videoImagen.to(item, {
      //                 x: -(boxWidth),
      //             })
      //         }else {
      //             videoImagen.to(item, {
      //                 opacity: 1,
      //             })
      //         }
      //     }
      //     else {
      //         let widthOdd = item.clientWidth
      //         item.style.right = `-${widthOdd}px`
      //         videoImagen.to(item, {
      //             x: -(boxWidth+widthOdd),
      //         })
      //     }

      //     if (totalItems > index+1) {
      //         videoImagen.to(lastItem, {
      //             opacity: 0,
      //         })
      //     }
      //     console.log(lastItem)
      //     lastItem = item
      // });
    });
}
